import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { getStoredUser, logout, isAuthenticated } from '../../utils/auth';
import { watchPushAndServiceWorkerEvents } from '../../utils/browserNotifications';
import GlobalSearch from '../Search/GlobalSearch';
import './Header.css';
import Icon from '../common/Icon';

const Header = ({ onMenuToggle }) => {
    const history = useHistory();
    const location = useLocation();
    const isMasterHome = location.pathname === '/my-day'
        && String(getStoredUser()?.role || '').toLowerCase() === 'master';
    const isMainPage = location.pathname === '/' || location.pathname === '/dashboard' || isMasterHome;

    useEffect(
        () => watchPushAndServiceWorkerEvents({ onNavigate: (url) => history.push(url) }),
        [history]
    );

    const getPageTitle = (pathname) => {
        if (pathname === '/' || pathname === '/dashboard') return 'Панель управления';
        if (pathname === '/my-day') return 'Мой день';
        if (pathname.startsWith('/clients')) return 'Клиенты';
        if (pathname.startsWith('/vehicles')) return 'Автомобили';
        if (pathname === '/orders') return 'Заказы';
        if (pathname === '/orders/completed') return 'Завершенные заказы';
        if (pathname === '/orders/new') return 'Новый заказ';
        if (pathname.startsWith('/orders/') && pathname.endsWith('/edit')) return 'Редактирование заказа';
        if (pathname.startsWith('/orders/')) return 'Детали заказа';
        if (pathname.startsWith('/services')) return 'Услуги';
        if (pathname === '/analytics') return 'Аналитика и отчеты';
        if (pathname === '/accounting') return 'Бухгалтерия';
        if (pathname === '/accounting/expenses') return 'Расходы по категориям';
        if (pathname === '/accounting/legacy') return 'Бухгалтерия: старый расчёт';
        if (pathname === '/accounting/template') return 'Шаблон бухгалтерии';
        if (pathname === '/settings/currency-rates') return 'Курсы валют';
        if (pathname === '/settings/notifications') return 'Уведомления';
        if (pathname === '/schedule') return 'Расписание мастеров';
        if (pathname === '/materials') return 'Материалы';
        if (pathname.startsWith('/dealerships')) return 'Автосалоны';
        if (pathname.startsWith('/users')) return 'Пользователи';
        if (pathname === '/settings/currency-rates') return 'Курсы валют';
        if (pathname === '/settings/notifications') return 'Управление уведомлениями';
        return 'Страница';
    };

    const handleLogout = () => {
        logout();
        history.push('/login');
    };

    const handleBack = () => {
        if (window.history.length > 1) {
            history.goBack();
            return;
        }
        history.push('/dashboard');
    };

    if (!isAuthenticated()) {
        return null;
    }

    return (
        <header className="top-header">
            <div className="header-content">
                <div className="header-title">
                    <button
                        type="button"
                        className="menu-icon-btn"
                        onClick={onMenuToggle}
                        aria-label="Открыть меню"
                    >
                        <Icon name="menu" size={20} />
                    </button>
                    <h2>{getPageTitle(location.pathname)}</h2>
                </div>
                <div className="header-actions">
                    <GlobalSearch />
                    {isMainPage ? (
                        <button onClick={handleLogout} className="logout-btn">
                            <Icon name="sign-out-alt" />
                            Выйти
                        </button>
                    ) : (
                        <button onClick={handleBack} className="back-btn">
                            <Icon name="arrow-left" />
                            Назад
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;